var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dsf_teas_learning_main" }, [
    _c("div", { staticClass: "dsf_teas_learning_date" }, [
      _c(
        "div",
        { staticClass: "icon-b", on: { click: _vm.reduce } },
        [_c("van-icon", { attrs: { name: "arrow-left" } })],
        1
      ),
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.weekName))]),
      _c(
        "div",
        { staticClass: "icon-b", on: { click: _vm.add } },
        [_c("van-icon", { attrs: { name: "arrow" } })],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "dsf_teas_learning_scroll_box" },
      [
        _c("dsf-mobile-teas-schedule-list", {
          attrs: { url: _vm.urlOfflineShift, "is-design": _vm.isDesign },
          on: { dialogRowClick: _vm.dialogRowClick },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }